// extracted by mini-css-extract-plugin
export default {"tooltipContainer":"UsersTooltip_tooltipContainer__l9lju","header":"UsersTooltip_header__I4t2B","usersList":"UsersTooltip_usersList__tPuUP","user":"UsersTooltip_user__ugE8Z"};